/**
 * MAS Direct save payload - delegates to shared MAS payload builder.
 * Isolated so Direct-specific payload changes can be made here without affecting Indirect.
 */
import { buildMASSavePayload } from '../../shared/utils/masPayloadBuilder';
import type { FormDataArrayItem } from '../../shared/utils/masPayloadBuilder.types';
import type { MASSavePayloadDeps } from '../../shared/utils/masPayloadBuilder.types';

export function buildMASDirectSavePayload(deps: MASSavePayloadDeps): FormDataArrayItem[] {
  return buildMASSavePayload(deps);
}
